<script type="ts">
	import type { IThemedToken } from "shiki";
	export let token: IThemedToken;
</script>
<span style="color: {token.color};">{token.content}</span>